/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { run, Carousel } from './SafetyAnalyticsSPS';

window.addEventListener('touchstart', (e) => {  // prevent page scrolling on mobile devices
  e.preventDefault();
});

const info = document.getElementById('info');
const elem = document.getElementById('carousel');
const video = document.getElementById('video') as HTMLVideoElement;
const progress = document.getElementById('progress');
const progressAmount = document.getElementById('progress-amount');
const viewer = document.getElementById('viewer');

const carousel = new Carousel(elem, video, info, 3.6, -20);
//run(viewer, carousel, './resources/events/');
run(viewer, carousel, './resources/events.json');

// * handle user video interaction *
const prevBtn = document.getElementById('prev');
const stopBtn = document.getElementById('stop');
const playBtn = document.getElementById('play');
const nextBtn = document.getElementById('next');

prevBtn.addEventListener('click', () => { carousel.prev(); clearProgress(); });
stopBtn.addEventListener('click', () => { carousel.stop(); clearProgress(); });
playBtn.addEventListener('click', () => { carousel.play(); });
nextBtn.addEventListener('click', () => { carousel.next(); clearProgress(); });

let zeroAfterUpdate = false;
function clearProgress() {
  progressAmount.style.width = '0';
  zeroAfterUpdate = true;
}

video.addEventListener('timeupdate', () => {
  const duration = video.duration;
  if (duration > 0) {
    progressAmount.style.width = ((video.currentTime / duration) * 100) + '%';
    if (zeroAfterUpdate) {
      zeroAfterUpdate = false;
      progressAmount.style.width = '0';
    }
  }
});

video.addEventListener('ended', () => {
  carousel.stop();
});

progress.addEventListener('click', (event) => {
  const w = progress.offsetWidth;
  const x = event.offsetX;
  video.currentTime = x / w * video.duration;
});

// * handle user interaction (touch) *
let from = 0;
let down = false;
let movement = 0;
elem.addEventListener('touchstart', (event) => {
  from = event.touches[0].pageX;
  down = true;
  movement = 0;
}, { passive: true });

elem.addEventListener('touchmove', (event) => {
  if (down) {
    movement = 0.8 * (event.touches[0].pageX - from) / document.body.clientWidth;
    carousel.stop();
    carousel.moveAbit(-movement);
  }
}, { passive: true });

elem.addEventListener('touchend', (event) => {
  if (movement !== 0) {
    down = false;
    carousel.moveFinal(-movement);
    clearProgress();
  } else {
    if (carousel.isPlaying()) {
      carousel.stop();
    } else {
      carousel.play();
    }
  }

}, { passive: true });
